import { useLangContext } from '../../../../../providers/LangProvider/LangProviderContext';
import { SlideMobileCloseAllPositionsStyled } from './styled/SlideMobileCloseAllPositionsStyled';
import { Loader } from '../../../../../components/Loader/Loader';
import amountFormat from '../../../../../utils/amountFormat';
import { Button, FormGroup } from 'react-bootstrap';
import React from 'react';
import classNames from 'classnames';

interface ISlideMobileCloseAllPositionsModalProps {
    amount: string,
    closeAllPositionsHandler: () => void,
    hasInactivePositions: boolean,
    isProgress: boolean,
    onClose: () => void,
    sumPl: number,
}

function SlideMobileCloseAllPositionsModal(props: ISlideMobileCloseAllPositionsModalProps) {
    const { getLangPath } = useLangContext();
    const { amount, isProgress, sumPl, hasInactivePositions, closeAllPositionsHandler, onClose } = props;

    return <SlideMobileCloseAllPositionsStyled>
        <Loader show={isProgress}/>
        <div className={classNames('title', {invisible: amount === '0'})}>{getLangPath('portfolio.positions.close_all.title', {
            amount,
        })}</div>
        <div className='pl'>
                <span
                    className={classNames({
                        positive: sumPl > 0,
                        negative: sumPl < 0,
                        invisible: sumPl === 0,
                    })}>{amountFormat(sumPl, 2, '$', false, {
                    toFixed: true,
                })}</span>
            <div>{getLangPath('portfolio.positions.close_all.pl')}</div>
        </div>
        <div
            className='describe'>{getLangPath(hasInactivePositions ? 'portfolio.positions.close_all.description_partial' : 'portfolio.positions.close_all.description')}</div>
        <FormGroup className={'mt-4 d-flex flex-column gap-2'}>
            <Button variant={'secondary'}
                    className={'w-100 negative'}
                    onClick={closeAllPositionsHandler}
            >{getLangPath(hasInactivePositions ? 'portfolio.positions.close_all.submit_partial' : 'portfolio.positions.close_all.submit')}</Button>
            <Button variant={'secondary'}
                    className={'w-100'}
                    onClick={onClose}
            >{getLangPath('portfolio.positions.close_all.cancel')}</Button>
        </FormGroup>
    </SlideMobileCloseAllPositionsStyled>;
}

export default SlideMobileCloseAllPositionsModal;
